import type { CityConfig } from "../city-template/types";

export const sandyUTConfig: CityConfig = {
  city: "Sandy",
  state: "Utah",
  stateAbbr: "UT",
  slug: "sandy-ut",
  route: "/sandy-ut",
  title: "Emergency Passport Sandy, UT | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Sandy, UT — as fast as 24 hours. Serving Salt Lake County and the Wasatch Front. A+ BBB rated registered State Dept. courier serving the South Valley and Cottonwood Heights corridor. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Sandy, UT",
  heroSubtitle: "Last-minute business trip to London from Salt Lake International in 5 days? Family ski vacation to the Swiss Alps and your passport is expired? Convention in Toronto and your documents are not ready? We help Sandy residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Sandy%20Utah%20suburban%20cityscape%20with%20Wasatch%20Mountains%20dramatic%20snow%20capped%20peaks%20in%20background%20South%20Valley%20landscape%20Lone%20Peak%20Twin%20Peaks%20silhouettes%20residential%20neighborhoods%20tree%20lined%20streets%20professional%20photography%20blue%20sky%20day%20light&width=1800&height=700&seq=sandy-ut-hero-2026&orientation=landscape",
  heroImageAlt: "Sandy Utah suburban landscape with Wasatch Mountains backdrop on a clear day",
  geoPosition: "40.5649;-111.8389",
  geoPlacename: "Sandy, Utah",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located in Aurora, CO — approximately 530 miles east of Sandy via I-80/I-25",
  },
  nearbyCitiesZips: [
    { name: "Sandy", zips: "84070, 84090, 84091, 84092, 84093, 84094" },
    { name: "Draper", zips: "84020" },
    { name: "Cottonwood Heights", zips: "84093, 84121" },
    { name: "Midvale", zips: "84047" },
    { name: "South Jordan", zips: "84095" },
    { name: "Riverton", zips: "84065" },
    { name: "Herriman", zips: "84096" },
    { name: "West Jordan", zips: "84084, 84088" },
    { name: "Alta", zips: "84092" },
    { name: "Holladay", zips: "84117, 84124" },
    { name: "Murray", zips: "84107, 84121" },
    { name: "Taylorsville", zips: "84118, 84123" },
    { name: "Salt Lake City", zips: "84101" },
    { name: "Bluffdale", zips: "84065" },
    { name: "Lehi", zips: "84043" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent South Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "South Valley Region", desc: "Serving Sandy, Draper, Cottonwood Heights, and the Wasatch Front" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Salt Lake City, UT", route: "/salt-lake-city" },
    { name: "Fast passport renewal in Provo, UT", route: "/provo" },
    { name: "Emergency passport help in Ogden, UT", route: "/ogden" },
    { name: "Urgent passport services in Orem, UT", route: "/orem" },
    { name: "Same-day passport help in Denver, CO", route: "/denver" },
    { name: "Passport courier services in St. George, UT", route: "/st-george" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Sandy remotely via secure courier. We do not have a walk-in office in Sandy — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Salt Lake County and the Wasatch Front.",
  fpcOfficeAddress: "299 S Main St, Salt Lake City, UT 84111",
  mapEmbedUrl: "https://www.google.com/maps?q=299+S+Main+St,+Salt+Lake+City,+UT+84111&output=embed",
  fpcOfficeDistance: "Serving all of Salt Lake County and the Wasatch Front south valley including Utah County",
  serviceAreaIntro: "From the bustling South Towne Center and the corporate offices of Sandy to the tech corridor of Draper and Silicon Slopes, from the mountain-adjacent neighborhoods of Cottonwood Heights to the family communities of South Jordan and Riverton, from the ski access points at the base of Little Cottonwood Canyon to the growing suburbs of Herriman and Bluffdale — Fast Passport Center serves the entire South Valley and Salt Lake metro region. We regularly help travelers from Sandy, Draper, and surrounding communities get their passports fast without the 530-mile drive to Denver.",
  nearbyCitiesIntro: "We serve all Sandy neighborhoods and the surrounding South Valley area including Draper, Cottonwood Heights, Midvale, South Jordan, Riverton, Herriman, Holladay, and Alta. If you are anywhere in southern Salt Lake County or northern Utah County, we have you covered.",
  howItWorksIntro: "Most Sandy travelers complete everything online and ship documents overnight. No need to drive to Denver or deal with downtown Salt Lake City — we handle the courier submission for you.",
  mistakesIntro: "Sandy travelers often face an 8-hour drive to the nearest regional passport agency in Denver. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Sandy and South Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Sandy? Here are the most common ones we hear from Wasatch Front travelers.",
  statePageRoute: "/states/utah",
  statePageName: "Utah",
  dmvWebsite: "https://dmv.utah.gov",
  dmvLabel: "Utah DMV — Division of Motor Vehicles",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Sandy travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Jennifer S.",
      location: "Sandy, UT",
      rating: 5,
      text: "Business trip to London in 4 days and my passport had expired. Fast Passport Center got my renewal in 30 hours. Sandy to London without a hitch. Unbelievable turnaround.",
      service: "Passport Renewal",
    },
    {
      name: "Craig L.",
      location: "Draper, UT",
      rating: 5,
      text: "Tech conference in Singapore with 6 days notice. Fast Passport Center processed my emergency passport in 28 hours. Silicon Slopes to Singapore — the dedicated agent was incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle D.",
      location: "Cottonwood Heights, UT",
      rating: 5,
      text: "Both kids needed first passports for a European family vacation. Fast Passport Center handled everything. Child passports in 4 days. Amazing service for Wasatch Front families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "sandy-ut-1",
      name: "Sandy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8850 S 700 E",
      city: "Sandy",
      state: "UT",
      zip: "84070",
      phone: "(801) 565-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Sandy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Sandy facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "sandy-ut-2",
      name: "Salt Lake County Clerk — South Office",
      type: "County Clerk Passport Acceptance",
      address: "10000 S Centennial Pkwy",
      city: "Sandy",
      state: "UT",
      zip: "84070",
      phone: "(385) 468-7400",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "South Sandy near South Towne",
      website: "https://slco.org/clerk",
      websiteLabel: "Salt Lake County Clerk",
      notes: "Accepts passport applications. Larger facility with more availability. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "sandy-ut-3",
      name: "Draper Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12180 S 300 E",
      city: "Draper",
      state: "UT",
      zip: "84020",
      phone: "(801) 571-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Sandy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Draper and south Sandy residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "sandy-ut-4",
      name: "South Jordan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10649 S Redwood Rd",
      city: "South Jordan",
      state: "UT",
      zip: "84095",
      phone: "(801) 254-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles west of Sandy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves South Jordan and west Sandy residents. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Denver", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Sandy photo shops sometimes use generic sizing. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Salt Lake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Sandy applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many South Valley families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Sandy travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Sandy." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Sandy address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Sandy before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Sandy for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Denver." },
    { q: "How fast can I renew my passport in Sandy?", a: "Fast Passport Center offers fast passport renewal in Sandy in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Sandy?", a: "The nearest regional passport agency to Sandy is the Denver Passport Agency, approximately 530 miles east via I-80/I-25. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Sandy without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Sandy?", a: "Same-day passport appointments are only available at the Denver Regional Passport Agency — approximately 8 hours from Sandy — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Salt Lake County and Wasatch Front residents." },
    { q: "Do you serve the entire South Valley region?", a: "Absolutely. Fast Passport Center serves the entire South Valley and Wasatch Front region including Sandy, Draper, Cottonwood Heights, Midvale, South Jordan, Riverton, and surrounding areas. Our courier service works seamlessly from any address in Salt Lake County." },
    { q: "Can I expedite a child passport in Sandy?", a: "Yes. Fast Passport Center expedites child passports in Sandy for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk South Valley families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Sandy with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Denver Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Sandy", address: "9151 S Quarry Bend Dr, Sandy, UT 84094", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Sandy", address: "8890 S 700 E, Sandy, UT 84070", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Sandy", address: "10305 S 1300 E, Sandy, UT 84094", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Draper", address: "2300 W 300 N, Draper, UT 84020", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Utah DMV — Sandy",
      address: "10186 S 700 E, Sandy, UT 84070",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Utah DMV — Draper",
      address: "14555 S 500 W, Draper, UT 84020",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Serves southern Salt Lake County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SLC",
      name: "Salt Lake City International Airport",
      distance: "20 miles north of Sandy",
      address: "776 N Terminal Dr, Salt Lake City, UT 84122",
      note: "Major international airport with direct flights worldwide. About 25 minutes from Sandy via I-15.",
      flightUrl: "https://www.slcairport.com/",
      flightLabel: "SLC Airport",
      featured: true,
    },
    {
      code: "PVU",
      name: "Provo Municipal Airport",
      distance: "32 miles south of Sandy",
      address: "3421 Mike Jense Pkwy, Provo, UT 84601",
      note: "Regional airport with limited commercial service. About 35 minutes from Sandy via I-15.",
      flightUrl: "https://www.provo.org/city-services/airport",
      flightLabel: "PVU Airport",
      featured: false,
    },
  ],
};